import { createContext, useContext } from 'react';
import { AttributeReferenceConfig } from 'pages/Financials/financials-widget-drawer/types';
import WidgetDrawer from '../../../components/Drawer/widget-drawer/WidgetDrawer';
import WidgetDrawerProps from '../../../components/Drawer/widget-drawer/WidgetDrawer.props';
import SheetAttributeManager from '../../../services/sheet-attribute-manager/SheetAttributeManager';

const AttributeMappedWidgetDrawerContext = createContext<{
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig?: AttributeReferenceConfig;
  handlePushingAttributeMappings?: () => void;
    }>({});

export const useAttributeMappedWidgetDrawer = () => useContext(AttributeMappedWidgetDrawerContext);

export interface AttributeMappedWidgetDrawerProps extends WidgetDrawerProps {
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig: AttributeReferenceConfig;
  handlePushingAttributeMappings?: () => void;
}

export const AttributeMappedWidgetDrawer = (props: AttributeMappedWidgetDrawerProps) => (
  <AttributeMappedWidgetDrawerContext.Provider
    value={{
      attributeMapper: props.attributeMapper,
      attributeReferenceConfig: props.attributeReferenceConfig,
      handlePushingAttributeMappings: props.handlePushingAttributeMappings,
    }}>
    <WidgetDrawer
      applicationContext={props.applicationContext}
      documentReferencesProps={props.documentReferencesProps}
      notesProps={props.notesProps}
      spreadsheetNotesProps={props.spreadsheetNotesProps}
      documentTabCustomActions={props.documentTabCustomActions}
      documentApplicationStorageKey={props.documentApplicationStorageKey}
    />
  </AttributeMappedWidgetDrawerContext.Provider>
);
